/****************************************************
 * Module Name:  dashboardProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class DashboardProxy {
  static GetAllUsersCount = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/dashboard/users/count",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetVendorsForDashboard = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/dashboard/lotintimation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUsersGradeCountByUserType = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/user/grade/count",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetKapanStatusSummaryCount = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/report/kapan/stonestatus/summary",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUsersByLocation = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/dashboard/user/bylocation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetBucketTransactions = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/dashboard/bucket/transactions",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
